<app-modal
  *ngIf="mainContent && secondaryAction && primaryAction"
  [modalTitle]="modalTitle"
  [mainContentTemplate]="mainContent"
  [secondaryActionTemplate]="secondaryAction"
  [primaryActionTemplate]="primaryAction"
  (closed)="activeModal.dismiss()"
></app-modal>

<ng-template #mainContent>
  @for (registrationType of registrationTypes; track registrationType.id) {
    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        [id]="registrationType.id"
        [(ngModel)]="selectedOption"
        [value]="registrationType.value"
      />
      <label class="form-check-label" [for]="registrationType.id">
        {{ registrationType.label | translate }}
      </label>
    </div>
  }
</ng-template>

<ng-template #secondaryAction>
  <button
    class="btn btn-falcon-default btn-sm me-3"
    type="button"
    (click)="handleSecondaryAction()"
  >
    {{ "general.cancel" | translate }}
  </button>
</ng-template>

<ng-template #primaryAction>
  <button
    class="btn btn-primary btn-sm"
    type="submit"
    (click)="handlePrimaryAction()"
  >
    {{ "general.next" | translate
    }}<span class="fas fa-chevron-right ms-2" data-fa-transform="shrink-3">
    </span>
  </button>
</ng-template>
